@if ({ isDesktop: isDesktop$ | async }; as asyncValues) {
  <header>
    <mat-toolbar class="toolbar-header">
      <a
        aria-label="Penn State home page"
        [href]="psuLink"
        rel="noopener noreferrer"
        target="_blank"
        data-cy="psu-header">
        <img
          alt="Penn State mark"
          [src]="psuHorizontalLogo | psuCdn"
          data-cy="psu-logo" />
      </a>
    </mat-toolbar>
  </header>

  <mat-sidenav-container class="app-container">
    <mat-sidenav
      class="sidenav"
      mode="side"
      opened
      fixedInViewport
      fixedTopGap="82"
      role="navigation"
      data-cy="app-sidenav">
      <cca-sidenav data-cy="sidenav-links" />
    </mat-sidenav>
    <mat-sidenav-content role="main">
      <div class="app-main mat-typography">
        <div class="main-content">
          <router-outlet></router-outlet>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
}
